/**
 * Dashboard API URLs
 * APIs for home dashboard - alerts, patterns, market overview
 */

const BASE_URL = "/api/dashboard";

const DASHBOARD_URLS = {
  // Summary
  SUMMARY: `${BASE_URL}/summary`,

  // Alerts
  ALERTS_RECENT: `${BASE_URL}/alerts/recent`,
  ALERT_DETAIL: `${BASE_URL}/alerts/`, // append alert_id
  ALERT_UPDATE_STATUS: `${BASE_URL}/alerts/`, // append alert_id/status

  // Patterns
  PATTERNS_RECENT: `${BASE_URL}/patterns/recent`,

  // Sectors
  SECTOR_PERFORMANCE: `${BASE_URL}/sectors/performance`,

  // Market Movers
  MARKET_MOVERS: `${BASE_URL}/market-movers`,

  // Indices
  INDICES_OVERVIEW: `${BASE_URL}/indices/overview`,

  // Price Data
  PRICE_HISTORY: `${BASE_URL}/prices/`, // append company_id/history
};

export { DASHBOARD_URLS };
